export default "__VITE_ASSET__e507142d__"